"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIconWrapper = exports.StyledSecureWrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledSecureWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  ", "\n"])), function (_a) {
    var space = _a.theme.space;
    return "\n  padding-top:  ".concat(space[4], ";\n  padding-bottom:  ").concat(space[3], ";\n");
});
exports.StyledIconWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var space = _a.theme.space;
    return "\n  padding-right:  ".concat(space[2], ";\n  @media only screen and (min-width: 992px) {  \n    display: flex;\n } \n  @media only screen and (max-width: 600px) {  \n    position: relative;\n    top: -").concat(space[2], ";\n  }\n");
});
var templateObject_1, templateObject_2;
